import { ActionTypes } from '../actions/actionTypes';

const initialstate = {
  selectedUser: null,
  selectedPassportType: 1,
  phone: '',
  code: '',
  client_id: 0,
  loading: false,
  error: 'information',
  title: 'Документы успешно загружены',
  subTitle: 'После рассмотрения обязательно сообщим о результате. Спасибо',
  uncorrectCode: false,
  lang: 'ru',
  redirect: 'default',
  isFromAuto: false,
  showModal: false,
};

export const mainReducer = (state = initialstate, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_PASSPORT_TYPE:
      return { ...state, selectedPassportType: action.payload.passportType };
    case ActionTypes.UNCORRECT_CODE: {
      return { ...state, uncorrectCode: action.payload };
    }
    case ActionTypes.CHANGE_NUMBER_FIELD: {
      const { name, value } = action.payload;
      return { ...state, [name]: value };
    }
    case ActionTypes.SELECT_USER: {
      return {
        ...state,
        selectedUser: action.payload,
        client_id: action.payload.id,
      };
    }
    case ActionTypes.RESTART_DATA: {
      state = initialstate;
      return state;
    }
    case ActionTypes.GET_OTP_ERROR:
      return { ...state, error: action.payload };
    case ActionTypes.SEND_FILES_ERROR:
      return { ...state, loading: false, error: action.payload };
    case ActionTypes.CHEKC_OTP_CODE_ERROR:
      return { ...state, error: action.payload, loading: false };
    case ActionTypes.UPDATE_CLIENT_ID:
      const { clientId } = action.payload;
      return { ...state, client_id: clientId };
    case ActionTypes.SET_TITLE:
      return { ...state, title: action.payload };
    case ActionTypes.SET_SUB_TITLE:
      return { ...state, subTitle: action.payload };
    case ActionTypes.SWITCH_LANG:
      return { ...state, lang: action.payload };
    case ActionTypes.REDIRECT:
      return { ...state, redirect: action.payload };
    case ActionTypes.THROW_ERROR_MESSAGE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        showModal: true,
      };
    case ActionTypes.CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        showModal: false,
      };

    default:
      return state;
  }
};
